module.exports = __webpack_public_path__ + "img/photo_2023-04-22_08-15-40.b9f8d291.jpg";